import React, { useContext } from 'react';

import type { UserLabelFragment } from '../../graphql/hasura/generated';
import { ModelsContext } from '../../hooks/providers';
import { formatTimestamp } from '../../utils';

interface IChangedAtTimeByUserProps {
  changedAt: string;
  changedByUser?: UserLabelFragment | null;
  tz?: string;
}

export const ChangedAtTimeByUser: React.FC<IChangedAtTimeByUserProps> = (props) => {
  const { changedAt, changedByUser, tz } = props;
  const { getModel } = useContext(ModelsContext);
  const UserModel = getModel('User');

  return (
    <>
      {formatTimestamp(changedAt, tz)}
      {changedByUser && (
        <> by {UserModel.routes.renderRowLink(changedByUser)}</>
      )}
    </>
  );
};
